import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Home,
  CheckCheck,
  BarChart3,
  Clock,
  Users,
  FileText,
  Settings2,
} from "lucide-react";

interface NavItem {
  icon: React.ComponentType<any>;
  label: string;
  path: string;
}

const navItems: NavItem[] = [
  { icon: Home, label: "Home", path: "/dashboard" },
  { icon: CheckCheck, label: "Result", path: "/result" },
  { icon: BarChart3, label: "Statistic", path: "/statistics" },
  { icon: Clock, label: "History", path: "/history" },
  { icon: Settings2, label: "Configuration", path: "/config" },
  { icon: FileText, label: "Documentation", path: "/documentation" },
  { icon: Users, label: "User Management", path: "/users" },
];

const Sidebar: React.FC = () => {
  const location = useLocation();

  return (
    <div className="w-64 shrink-0 bg-white shadow-lg rounded-2xl m-4 h-[calc(100vh-2rem)] sticky top-4">
      {/* Logo */}
      <div className="mx-auto w-24 h-24 flex items-center justify-center m-6 rounded-xl">
              <img
                src="/assets/galaxy_logo_blue.jpg"
                alt="Galaxy Logo"
                className="w-50 h-50 object-contain"
                style={{ background: "tranparent", borderRadius: "0.75rem" }}
              />
            </div>

      {/* Navigation */}
      <nav className="px-4 pb-4">
        {navItems.map((item, index) => {
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={index}
              to={item.path}
              className={`flex items-center gap-3 px-4 py-3 rounded-lg mb-2 cursor-pointer transition-colors ${
                isActive
                  ? "bg-blue-100 text-blue-700 font-medium"
                  : "text-gray-600 hover:bg-gray-100"
              }`}
            >
              <item.icon size={20} />
              <span className="text-sm flex flex-col">
                {item.label}
                {item.label === "User Management" && (
                  <span className="italic text-gray-400 text-xs leading-tight">
                    (Future Plan)
                  </span>
                )}
              </span>
            </Link>
          );
        })}
      </nav>
    </div>
  );
};

export default Sidebar;
